import cn from 'classnames';

import Link from 'components/link/Link';

import { IPagination } from 'source/NFR.types';

const Pagination: React.FC<IPagination> = ({ pages = [], title }) =>
  pages.length > 0 ? (
    <nav className="pagination">
      {title && <h2>{title}</h2>}
      <ul>
        {pages?.map(
          page =>
            page.link && (
              <li key={page.link.text}>
                <Link
                  className={cn('pagination--link', {
                    'pagination--link--is-current': page.isCurrent
                  })}
                  aria-label={page.label}
                  aria-current={page.isCurrent ? 'page' : undefined}
                  {...page.link}
                />
              </li>
            )
        )}
      </ul>
    </nav>
  ) : null;

Pagination.displayName = 'Pagination';

export default Pagination;
